import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 md:py-28 bg-sage-light/30" data-id="element-153">
      <div className="max-w-3xl mx-auto px-6" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-10 md:p-16 shadow-lg border border-sage/20 text-center" data-id="element-155">
          <div className="w-24 h-24 bg-sage-light rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-156">
            <ShieldCheck className="w-12 h-12 text-sage" strokeWidth={1.5} data-id="element-157" />
          </div>

          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-sage uppercase mb-4" data-id="element-158">
            GARANTÍA 7 DÍAS — SIN RIESGO
          </span>

          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-8" style={{
          fontSize: 'clamp(2rem, 5vw, 3.5rem)'
        }} data-id="element-159">
            Probalo tranquila
          </h2>

          <div className="space-y-4 text-lg text-text-muted" data-id="element-160">
            <p data-id="element-161">Abrís el ebook. Lo leés. Lo aplicás a tu ritmo.</p>
            <p data-id="element-162">
              Si en 7 días sentís que no era lo que necesitabas, te devolvemos
              el 100% de tu dinero.
            </p>
            <p className="font-serif italic text-peach-dark text-2xl pt-4" data-id="element-163">
              Sin preguntas. Sin complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}